import { Box } from '@material-ui/core';
import classNames from 'classnames';
import React, { FC } from 'react';
import css from './Divider.module.css';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

interface DividerProps {
  className?: string;
  color?: string;
}

const Divider: FC<DividerProps> = (props: DividerProps) => {
  const { className, color } = props;
  const { shopColor10 } = useDefaultShopStyles();

  return <Box className={classNames(css.root, className)} bgcolor={color || shopColor10} />;
};

export default Divider;
